<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('sumaryMaterial.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('sumaryMaterial.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="filter-section">
            <div class="filter-title mb-3 ts-flex ts-items-center">
              <a-icon type="filter" />
              <span class="ml-2">{{ $t('sumaryMaterial.filter') }}</span>
            </div>
            <div class="row gutter-row">
              <div class="col-md-4">
                <div class="filter-item">
                  <label class="required">
                    <i class="fas fa-project-diagram"></i>
                    <span class="ml-1">{{ $t('sumaryMaterial.project') }}</span>
                  </label>
                  <a-select
                    v-model="model.project_id"
                    :options="projects"
                    showSearch
                    @change="handleProjectChange"
                    :filterOption="filterOption"
                    placeholder="--select--"
                    mode="multiple"
                    class="ts-w-full"
                    :max-tag-count="1"
                    :maxTagTextLength="40"
                    allowClear
                  >
                  </a-select>
                  <div class="validate" v-if="errors.has('project_id')">
                    {{ errors.first('project_id') }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="filter-item">
                  <label>
                    <i class="fas fa-users"></i>
                    <span class="ml-1">{{
                      $t('sumaryMaterial.milestoneOwner')
                    }}</span>
                  </label>
                  <a-select
                    v-model="model.milestone_owner_id"
                    :options="owners"
                    showSearch
                    :filterOption="filterOption"
                    placeholder="--select--"
                    mode="multiple"
                    class="ts-w-full"
                    :max-tag-count="1"
                    @change="handleMilestoneOwnerChange"
                  >
                  </a-select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="filter-item">
                  <label>
                    <i class="far fa-flag"></i>
                    <span class="ml-1">{{
                      $t('sumaryMaterial.milestone')
                    }}</span>
                  </label>
                  <a-select
                    v-model="model.milestone_id"
                    :options="milestones"
                    showSearch
                    :filterOption="filterOption"
                    placeholder="--select--"
                    mode="multiple"
                    class="ts-w-full"
                    :max-tag-count="1"
                  >
                  </a-select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="filter-item">
                  <label>
                    <i class="fas fa-users"></i>
                    <span class="ml-1">{{
                      $t('sumaryMaterial.taskOwner')
                    }}</span>
                  </label>
                  <a-select
                    v-model="model.task_owner_id"
                    :options="owners"
                    showSearch
                    :filterOption="filterOption"
                    placeholder="--select--"
                    mode="multiple"
                    class="ts-w-full"
                    :max-tag-count="1"
                  >
                  </a-select>
                </div>
              </div>
            </div>
            <div class="row ts-mt-3">
              <div class="col-md-4">
                <div class="filter-actions">
                  <ts-button @click="onPreview" color="primary">
                    <a-icon type="search" />
                    <span class="ml-1">{{ $t('preview') }}</span>
                  </ts-button>
                  <ts-button @click="exportExcel" color="info" class="ml-2">
                    <a-icon type="download" />
                    <span class="ml-1">{{ $t('excel') }}</span>
                  </ts-button>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-12">
              <a-table
                :columns="columns"
                :data-source="materials"
                :pagination="pagination"
                @change="handleTableChange"
                size="middle"
              >
              </a-table>
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { trim } from 'lodash'
import * as FileDownload from 'downloadjs'
export default {
  name: 'summaryMaterial',
  data() {
    return {
      projects: [],
      milestones: [],
      owners: [],
      model: {
        project_id: undefined,
        milestone_id: undefined,
        milestone_owner_id: undefined,
        task_owner_id: undefined
      },
      errors: new Errors(),
      loading: false,
      materials: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('sumaryMaterial.project'),
          dataIndex: 'project_name',
          key: 'project_name'
        },
        {
          title: this.$t('sumaryMaterial.milestone'),
          dataIndex: 'milestone_name',
          key: 'milestone_name'
        },
        {
          title: this.$t('sumaryMaterial.status'),
          dataIndex: 'project_status',
          key: 'project_status'
        },
        {
          title: this.$t('sumaryMaterial.completedDate'),
          dataIndex: 'completed_at',
          key: 'completed_at'
        },
        {
          title: this.$t('sumaryMaterial.barcode'),
          dataIndex: 'barcode',
          key: 'barcode'
        },
        {
          title: this.$t('sumaryMaterial.productName'),
          dataIndex: 'product_name_en',
          key: 'product_name_en'
        },
        {
          title: this.$t('sumaryMaterial.uom'),
          dataIndex: 'uom_name_en',
          key: 'uom_name_en'
        },
        {
          title: this.$t('sumaryMaterial.quantity'),
          dataIndex: 'total_quantity',
          key: 'total_quantity'
        }
      ]
    }
  },
  mounted() {
    this.fetchResourceBase()
  },
  methods: {
    ...mapActions('report/project', [
      'getProject',
      'getOwner',
      'summaryMaterial',
      'getMilestone',
      'summaryMaterialExcel'
    ]),

    async fetchResourceBase() {
      try {
        this.loading = true
        const [projectResponse, ownerResponse] = await Promise.all([
          this.getProject(),
          this.getOwner()
        ])

        this.projects = projectResponse.map(el => ({
          value: el.project_id,
          label: el.project_name
        }))

        this.owners = ownerResponse.map(el => ({
          value: el.employee_id,
          label: el.employee_name_en
        }))
      } catch (err) {
        this.$toasted.error(err.message)
      } finally {
        this.loading = false
      }
    },

    async handleProjectChange() {
      this.model.milestone_id = undefined // Reset milestone selection
      this.milestones = [] // Clear milestone options
      this.pagination.current = 1 // Reset to first page
      await this.fetchMilestones()
    },
    async handleMilestoneOwnerChange() {
      this.model.milestone_id = undefined // Reset milestone selection
      this.milestones = [] // Clear milestone options
      this.pagination.current = 1 // Reset to first page

      if (
        this.model.milestone_owner_id &&
        this.model.milestone_owner_id.length
      ) {
        await this.fetchMilestones()
      }
    },
    async fetchMilestones() {
      this.loading = true
      await this.getMilestone({
        project_id: this.model.project_id,
        milestone_owner_id: this.model.milestone_owner_id
      })
        .then(response => {
          this.milestones = response.map(el => ({
            value: el.milestone_id,
            label: el.milestone_name
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.onPreview()
    },
    onPreview() {
      this.loading = true
      this.errors = new Errors()

      // Replace this with your actual API call
      this.summaryMaterial({ ...this.model, ...this.pagination })
        .then(response => {
          this.materials = response.data.data
          this.pagination.total = response.data.total
        })
        .catch(err => {
          this.$toasted.error(err.message)
          this.errors = new Errors(err.errors)
        })
        .finally(() => (this.loading = false))
    },
    exportExcel() {
      this.loading = true
      this.errors = new Errors()
      this.summaryMaterialExcel(this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
<style scoped>
.filter-section {
  background-color: #fafafa;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}

.filter-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #1890ff;
}

.filter-item label {
  display: block;
  margin-bottom: 0.5rem;
  color: #595959;
  font-weight: 500;
}

.filter-actions {
  display: flex;
  align-items: flex-start;
  height: 100%;
  /* padding-top: 1.5rem; */
}

.gutter-row {
  margin: -8px;
}

.gutter-row > div {
  padding: 8px;
}
</style>
